export const DAYS = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];

export const MONTHS = [
  'Januari',
  'Februari',
  'Maart',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Augustus',
  'September',
  'Oktober',
  'November',
  'December',
];
